import api from './api'

export type OutlineContextMode = 'SIMPLIFIED' | 'FULL'

export interface Novel {
  id: number
  title: string
  description: string
  genre?: string
  status: string
  creationStage?: string
  outline?: string
  outlineContextMode?: OutlineContextMode
  wordCount: number
  chapterCount: number
  createdBy: number
  createdAt: string
  updatedAt: string
  // 新增创作配置字段
  targetTotalChapters?: number
  wordsPerChapter?: number
  plannedVolumeCount?: number
  totalWordTarget?: number
}

interface CreateNovelRequest {
  title: string
  description: string
  outlineContextMode?: OutlineContextMode
  // 新增创作配置字段
  targetTotalChapters?: number
  wordsPerChapter?: number
  plannedVolumeCount?: number
  totalWordTarget?: number
}

interface UpdateNovelRequest {
  title?: string
  description?: string
  genre?: string
  status?: string
  outlineContextMode?: OutlineContextMode
  // 新增创作配置字段
  targetTotalChapters?: number
  wordsPerChapter?: number
  plannedVolumeCount?: number
  totalWordTarget?: number
}
class NovelService {
  // 兼容方法：部分页面使用 getById，这里提供别名以保持兼容
  async getById(id: number | string): Promise<Novel> {
    const numericId = typeof id === 'string' ? parseInt(id, 10) : id
    return this.getNovelById(numericId)
  }

  async getNovels(page: number = 0, size: number = 10): Promise<Novel[]> {
    try {
      const response = await api.get(`/novels?page=${page}&size=${size}`)
      const data = response as unknown as any

      console.log('getNovels response:', data)

      // 如果返回的是分页数据，提取content数组
      if (data && typeof data === 'object' && 'content' in data && Array.isArray(data.content)) {
        return data.content as Novel[]
      }

      // 如果直接是数组，返回数组
      if (Array.isArray(data)) {
        return data as Novel[]
      }

      // 其他情况返回空数组
      console.warn('Unexpected response format:', data)
      return []
    } catch (error) {
      console.error('Error fetching novels:', error)
      return []
    }
  }

  async getNovelById(id: number): Promise<Novel> {
    const response = await api.get(`/novels/${id}`)
    return response as unknown as Novel
  }

  async createNovel(novelData: CreateNovelRequest): Promise<Novel> {
    const response = await api.post('/novels/simple', novelData)
    return response as unknown as Novel
  }

  async updateNovel(id: number, novelData: UpdateNovelRequest): Promise<Novel> {
    const response = await api.put(`/novels/${id}`, novelData)
    return response as unknown as Novel
  }

  async deleteNovel(id: number): Promise<void> {
    await api.delete(`/novels/${id}`)
  }
}

export const novelService = new NovelService()
export default novelService
